// extracted by mini-css-extract-plugin
export default {"container":"SingleTextInput_container__r5UWI","label":"SingleTextInput_label__wumdJ","input":"SingleTextInput_input__I1NH+"};